import { Dispatcher } from 'flux';

const AppDispatcher = new Dispatcher();

const register = (actionType, callback = () => { }) => {
    return AppDispatcher.register(function (payload) {
        if (payload.actionType === actionType) {
            callback(payload);
        }
    });
}

const unregister = (token) => {
    try{
        AppDispatcher.unregister(token);
    } catch (e) {
        /* eslint-disable no-console */
        console.log(e);
        /* eslint-enable no-console */
    }
}

const dispatch = (actionType, value = null) => {
    if(AppDispatcher.isDispatching()){
        setTimeout(() => dispatch(actionType, value), 0);
        return false;
    }
    AppDispatcher.dispatch({
        actionType,
        value
    });
}

const PubSub = {
    register,
    unregister,
    dispatch,
}

export default PubSub;

export {
    AppDispatcher
}
